<footer class="footer">
  <div>
    <span>&copy; {{c_year}} <span class="tx-medium">ME Group</span>, All rights reserved.</span>
  </div>
</footer>
